import { Customer } from '@/types';
import { useAtomValue } from 'jotai';
import { customerAtom } from '@/store';

export const useCustomer = () => useAtomValue(customerAtom) as Customer;
